import { EditorState, convertToRaw } from 'draft-js';
import { trimEditorContent } from '.';

export const formatEditorState = (editorState: EditorState) => {
  // trim starting newline and ending newline
  const trimmedEditorState = trimEditorContent(editorState);
  const trimmedContent = trimmedEditorState.getCurrentContent();
  const rawContent = convertToRaw(trimmedContent);
  const { blocks, ...restContent } = rawContent || [];
  const startIndex: number = blocks.findIndex((block) => !!block.text);
  const endIndex: number =
    blocks.length - 1 - blocks.reverse().findIndex((block) => !!block.text);
  const slicedBlocks = blocks.reverse().slice(startIndex, endIndex + 1);
  return JSON.stringify({ blocks: slicedBlocks, ...restContent });
};
